import { MediaBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/mediaBlock/mediaBlock.layout'
import { onlyNumbers } from '@shared/Frontend/utils/numbers'
import { PublicSiteState } from "../../../../../../root/state"
import * as React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { cookiebar, is_cookie_accepted } from '../cookiebar/cookiebar.widget.mod'
import { CMSState, ImageSize } from '../types.gen'

export type MediaItem = {
  kind_media: 'image' | 'video'
  image?: number
  image_alt?: string
  image_option: string
  size?: ImageSize
  get_default_data_src: () => ImageSize
  get_default_data_srcset: () => [ImageSize, string][]
  video?: { url: string } & {
    id: string
    type: string
    width: string
    height: string
    frameBorder: string
    allowFullScreen: boolean
  }
  caption?: string
  source?: string
  useCookieBar: boolean
  cookiePlaceholder: JSX.Element | string
  cookieButton: string
}

export type MediaBlockProps = {
  index: number
  title?: string
  intro?: string
  items: MediaItem[]
}

export function MediaBlock(
  props: MediaBlockProps
): (
  cmsState: CMSState,
  set_public_site: (output: Updater<PublicSiteState>) => void
) => (
  public_state: PublicSiteState
) => Widget<Updater<CMSState>> {
  return (cmsState: CMSState, set_public_site) => (public_state) =>
    fromJSX(() => {
        const imageSrc = (item: MediaItem) => {
          const image = cmsState.images.get(item.image)
          // We know this is always loaded, see `image_utils.mod.ts`
          if (image.kind != 'loaded') {
            throw new Error(
              `Image with id ${item.image} is not loaded yet. Ensure that the image is loaded before accessing its value.`
            )
          }
          return image.value
        }
        return (
          <>
            <MediaBlockLayout
              id={props.index.toString()}
              videoCookieAccepted={is_cookie_accepted('video-cookies')}
              cookiebarElement={cookiebar(public_state.cookiestate, 'video-cookies', 'ls-columns__main').run((a_cs) => {
                set_public_site((s1) => {
                  return { ...s1, cookiestate: a_cs(s1.cookiestate) }
                })
              })}
              title={props.title}
              intro={props.intro}
              items={props.items.map((item) => {
                return item.kind_media === 'video'
                  ? {
                      mediaType: 'video',
                      displayOption: item.image_option == 'full-width' ? 'full-width' : 'content-width',
                      url: item.video.url,
                      caption: item.caption
                    }
                  : item.kind_media == 'image' && item.image != null && cmsState.images.has(item.image)
                  ? {
                      mediaType: 'image',
                      displayOption: item.image_option == 'full-width' ? 'full-width' : 'content-width',
                      caption: item.caption,
                      image: {
                        alt: item.image_alt,
                        src: imageSrc(item).get(item.get_default_data_src()),
                        crops: item.get_default_data_srcset().map(([ url, width ]) => ({
                          url: imageSrc(item).get(url),
                          width: Number(onlyNumbers(width))
                        }))
                      }
                    }
                  : null
              })}
            />
          </>
        )
      }
    )
}
